import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import ContentSections from "./components/ContentSections";
import Footer from "./components/Footer";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://basetaosheet.top";

const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "BaseTao Spreadsheet Guide",
  "url": siteUrl + "/",
  "description": "Comprehensive guides, reviews, and tutorials about BaseTao Spreadsheet for international shoppers.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": siteUrl + "/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <ContentSections />
      </main>
      <Footer />
    </div>
  );
}